import { isToday } from './format';

export type ActivityFilter = 'today' | 'upcoming' | 'done';

/**
 * Whether an activity is still listed under `filter` once it has `status`.
 *
 * Mirrors the section filters on the activities screen: only the Today section
 * keeps finished activities, every other section and the Upcoming tab drop
 * them, and the Done tab drops anything unfinished. The screen offers an undo
 * banner exactly when this is false, because the checkbox the user tapped has
 * then left the screen with the activity.
 */
export function staysVisible(
  filter: ActivityFilter,
  startTime: string | null | undefined,
  status: string,
): boolean {
  const finished = status === 'done' || status === 'skipped';
  switch (filter) {
    case 'today':
      return !finished || isToday(startTime ?? null);
    case 'upcoming':
      return !finished;
    case 'done':
      return finished;
  }
}
